var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "#116C3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7507 0.441406L6.63456 4.09358L2.55013 0.441406L0.650391 2.10149L6.63456 7.44141L12.6504 2.10149L10.7507 0.441406Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSharp);
export default __webpack_public_path__ + "static/media/chevron-sharp.250446175a1cced85fa9a762686b191b.svg";
export { ForwardRef as ReactComponent };